export const APP_NAME = 'National Latin Exam Practice';
